/** Read numeric roleId from persisted session (login stores `role`). */
export function readLocalSessionRole() {
  try {
    const u = JSON.parse(localStorage.getItem("_bna") || "{}");
    if (u?.role == null) return null;
    return Number(u.role);
  } catch {
    return null;
  }
}

/**
 * Normalize GET /admin/me/permissions body (handles nested `data`, snake_case, omitted flags).
 * Super Admin should receive `isSuperAdmin: true` plus a full `permissions` matrix from the API.
 * Legacy fallback: roleId 1 + `permissions == null` still infers super admin when the flag is missing.
 */
export function normalizeMePermissionsPayload(p) {
  if (!p || typeof p !== "object") {
    return { isSuperAdmin: false, permissions: null };
  }
  const src =
    p.data && typeof p.data === "object" && !Array.isArray(p.data)
      ? { ...p, ...p.data }
      : { ...p };

  const flag = src.isSuperAdmin ?? src.is_super_admin;
  let isSuperAdmin = false;
  if (flag === true || flag === 1 || String(flag).toLowerCase() === "true") {
    isSuperAdmin = true;
  } else if (flag === false || flag === 0 || String(flag).toLowerCase() === "false") {
    isSuperAdmin = false;
  } else {
    const role = readLocalSessionRole();
    if (role === 1 && src.permissions == null) {
      isSuperAdmin = true;
    }
  }

  return { ...src, isSuperAdmin };
}
